<template>
  <ValidationProvider
    ref="provider"
    v-slot="{ validate, errors }"
    :rules="rules"
  >
    <form enctype="multipart/form-data">
      <div class="dropbox h-full">
        <input
          v-if="!newFile"
          type="file"
          name="file"
          :accept="fileTypes"
          class="input-file z-10"
          :required="required"
          @change="filesChange($event.target.name, $event.target.files)"
        >
        <img
          v-if="demoImage && demoIsImage"
          class="max-w-full max-h-full"
          :src="demoImage"
          :alt="demoImage"
          @click="reset"
        >
        <p
          v-else-if="existingFile"
          class="dbox-content w-full  break-words"
          @click="reset"
        >
          <a
            target="_blank"
            rel="noopener noreferrer"
            :href="existingFile"
          >{{
            existingFile
          }}</a>
        </p>
        <p
          v-else-if="newFile"
          class="dbox-content w-full break-words"
          @click="reset"
        >
          {{ newFile.name }}
        </p>
        <slot
          v-else
          class="z-10"
        >
          <p class="dbox-content">
            {{ uploadMessage }}
          </p>
        </slot>
      </div>
    </form>
  </ValidationProvider>
</template>
<script>
import { ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
extend('required', {
  ...required,
  message: 'This field is required',
})
const imageTypeList = ['.jpg', '.jpeg', '.png', '.JPG']
export default {
  name: 'XnFileInput',
  components: { ValidationProvider },
  props: {
    uploadMessage: {
      type: String,
      default: 'Drag file here or click to browse.',
    },
    existingFile: { type: String, default: undefined },
    fileTypes: {
      type: Array,
      default: () => {
        return []
      },
    },
    maxSize:{
      type:Number,
      default:()=>10000000
    },
    maxSizeMessage:{
      type:String,
      default:()=>'Please select a smaller file.'
    },
    required: {
      type: Boolean,
      default: () => true,
    },
  },
  data: function () {
    return {
      newFile: null,
      demoImage: this.existingFile,
    }
  },
  computed: {
    demoIsImage () {
      if (this.demoImage === undefined) {
        return false
      }
      var name = this.newFile ? this.newFile.name : this.existingFile
      if (name) {
        for (var fileType in imageTypeList) {
          if (name.includes(imageTypeList[fileType])) {
            return true
          }
        }
      }
      return false
    },
    rules () {
      return {
        required: this.required,
      }
    },
  },
  mounted () {
    this.reset()
  },
  methods: {
    reset () {
      this.newFile = null
      this.demoImage = null
      this.filesChange(null, null)
    },
    filesChange (fieldName, fileList) {
      let self = this
      if (!fileList||!fileList.length) {//replace with optional chaining with update of Node
        self.$emit('new-file-added', null)
        self.$emit('new-demo-image', null)
        return
      }
      let filePointer = fileList[0]
      let filetype = filePointer.name.split('.').pop()
      let goodFileType = self.fileTypes === undefined //if there is a list of filetypes it will return false requiring to match one, otherwise anything is good
      let alertString = 'Please select a file of the following types: '
      for (var typeLoc in self.fileTypes) {
        let type = self.fileTypes[typeLoc]
        alertString = alertString + type + ', '
        if (type.includes(filetype)) {
          goodFileType = true
          break
        }
      }
      if (!goodFileType) {
        alert(alertString)
        return
      }
      if(self.maxSize<filePointer.size){
        alert(`File size should be less than ${self.maxSize/1000000} MB. ${self.maxSizeMessage}`)
        return
      }
      self.demoImage = window.URL.createObjectURL(filePointer)
      self.newFile = filePointer
      // self.$refs.provider.syncValue(self.newFile)
      // self.$refs.provider
      //   .validate(self.newFile)
      //   .then(val => self.$refs.provider.applyResult(val))
      self.$emit('new-file-added', self.newFile)
      self.$emit('new-demo-image', self.demoImage)
    },
  },
}
</script>
<style lang="postcss" scoped>
.dropbox {
  --dropbox-color: #d9d9d9;
  @apply cursor-pointer border-2 border-dashed hover:bg-primary hover:opacity-25 rounded;
  min-height: 50px; /* minimum height */
  position: relative;
  text-align: center;
  text-justify: center;
  border-color: var(--dropbox-color);
  color: var(--dropbox-color);
  padding: 22px 40px 22px 40px;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  top: 0;
  cursor: pointer;
}
.dropbox .dbox-content {
  margin: auto;
  font-size: var(--h5);
  line-height: var(--h5);
  text-align: center;
  text-justify: center;
}
</style>
